<template>
  <DxButton class="chiclet"
            template="buttonTemplate"
            :style="`background-color: ${ tagColor }`"
  >
    <template #buttonTemplate>
      <p>{{ tagName }}</p>
    </template>
  </DxButton>
</template>

<script setup>
  import DxButton from 'devextreme-vue/button'

  const props = defineProps(['tagName', 'tagColor'])
</script>

<style lang="scss">
  .chiclet {
    font-size: 8pt !important;
    font-weight: bold !important;
    color: white !important;
    border: none !important;
    height: 20px;

    .dx-button-content {
      padding: 0 4px 0 4px !important;
      margin: 0;
      line-height: 19px;
    }
  }
</style>
